<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 个人设置
                </el-breadcrumb-item>
                <el-breadcrumb-item>个人信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="form-box">
                <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item label="真实姓名" prop="realName">
                        <el-input v-model="form.realName" placeholder="真实姓名"></el-input>
                    </el-form-item>
					<el-form-item label="合同签名" prop="signature">
                        <el-input v-model="form.signature" placeholder="合同签名"></el-input>
                    </el-form-item>
					<el-form-item label="手写签名" prop="handwriting">
						<el-upload
							class="upload-demo"
							:before-upload="beforeUpload"
							:action= "handwritingUploadUrl"
							:on-success="handwritingUploadSuccess"
							:on-remove="handwritingHandleRemove"
							:file-list="handwritingFileList"
							accept=".png,.jpg"
							list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="性别" prop="sex">
                        <el-radio-group v-model="form.sex">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
					<el-form-item label="联系电话" prop="tel">
                        <el-input v-model="form.tel" placeholder="联系电话"></el-input>
                    </el-form-item>
					<el-form-item label="邮箱" prop="mail">
                        <el-input v-model="form.mail" placeholder="邮箱"></el-input>
                    </el-form-item>
					<el-form-item label="QQ号" prop="qqName">
                        <el-input v-model="form.qqName" placeholder="QQ号"></el-input>
                    </el-form-item>
					<el-form-item label="微信号" prop="wechatName">
                        <el-input v-model="form.wechatName" placeholder="微信号"></el-input>
                    </el-form-item>
                    <el-form-item label="生日" prop="birthday">
                        <el-col>
                            <el-date-picker
                                type="date"
                                placeholder="选择日期"
                                v-model="form.birthday"
                                value-format="yyyy-MM-dd"
                                style="width: 100%;"
                            ></el-date-picker>
                        </el-col>
                    </el-form-item>
					<el-form-item label="头像" prop="portrait">
						<el-upload
							class="upload-demo"
							:action= "uploadUrl"
							:before-upload="beforeUpload"
							:on-success="uploadPortraitSuccess"
							:on-remove="handlePortraitRemove"
							:file-list="portraitFileList"
							accept=".png,.jpg"
							list-type="picture">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
						</el-upload>
					</el-form-item>
					<el-form-item label="消息接受" prop="acceptMessageEnable">
						<el-switch v-model="form.acceptMessageEnable"></el-switch>
					</el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" v-prevent-re-click>提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getCurrentUser, updateCurrentUser, removeImg } from '../../../api/index';
export default {
    name: 'personal',
    data() {
		let checkEmail = (rule, value, callback) => {
			const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
			if (value) {
				setTimeout(() => {
					if (mailReg.test(value)) {
						callback()
					} else {
						callback(new Error('请输入正确的邮箱格式'))
					}
				}, 100)
			} else {
				callback()
			}
		}
        return {
            form: {
				
            },
            rules: {
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
				signature: [{ required: true, message: '请输入合同签名', trigger: 'blur' }],
                sex: [{ required: true, message: '请选择性别', trigger: 'blur' }],
				tel: [{ required: true, message: '请输入电话', trigger: 'blur' }],
				mail: [{ validator: checkEmail, trigger: 'blur' }],
				birthday: [{ required: true, message: '请选择生日', trigger: 'blur' }]
            },
			imgPrefix:"/image",
			uploadUrl : "/image/upload/10",
			handwritingUploadUrl:"/image/upload/22",
			portraitFileList:[],
			handwritingFileList:[],
			controll:{}
        };
    },
	created() {
		this.controll = getControll("personal");
		let ckey = localStorage.getItem('ms_ckey');
		this.uploadUrl = "/image/upload/" + ckey + "/10";
		this.handwritingUploadUrl="/image/upload/" + ckey + "/22";
		this.getUserInfo();
    },
    methods: {
		getUserInfo() {
			getCurrentUser().then(res => {
				if (res.code == 0) {
					this.form = res.data;
					if (res.data.portrait) {
						let portraitJson = {};
						portraitJson['url'] = this.imgPrefix + res.data.portrait;
						this.portraitFileList.push(portraitJson);
					}
					if (res.data.handwriting) {
						let handwritingJson = {};
						handwritingJson['url'] = this.imgPrefix + res.data.handwriting;
						this.handwritingFileList.push(handwritingJson);
					}
				} else {
					this.$message.error(res.message);
				}
			});
		},
        onSubmit() {
			this.$refs.form.validate(valid => {
				if (valid){
					updateCurrentUser(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('更新成功！');
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
        },
		//头像上传
		uploadPortraitSuccess(response, file, fileList) {
			this.form.portrait = response.data;
		},
		//删除头像图片
		handlePortraitRemove(file, fileList) {
			if (!this.form.portrait) {
				return;
			}
			removeImg([this.form.portrait]).then(res => {
				if (res.code == 0 ) {
					this.form.portrait = "";
					this.$message.success("删除头像成功");
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//手写签名上传
		handwritingUploadSuccess(response, file, fileList) {
			this.form.handwriting = response.data;
		},
		//删除手写签名图片
		handwritingHandlePortraitRemove(file, fileList) {
			if (!this.form.handwriting) {
				return;
			}
			removeImg([this.form.handwriting]).then(res => {
				if (res.code == 0 ) {
					this.form.handwriting = "";
					this.$message.success("删除手写签名成功");
				} else {
					this.$message.error("获取手写签名失败！" + res.message);
				}
			});
		},
		beforeUpload(file){
			let limit = file.size / 1024 < 1024;
			if (!limit) {
			  this.$message.error('上传文件大小不能超过 1M');
			  return false;
			}
			return true;
		}
    }
};
</script>